import React, { useState, useEffect, useRef } from 'react';
import './TrustedInstitutions.css';

function proxy(url) {
  return 'https://wsrv.nl/?url=' + encodeURIComponent(url);
}

var COLLEGES = [
  { id: 1, name: 'Holy Cross Engineering College',        img: proxy('https://ibots.in/wp-content/uploads/elementor/thumbs/images-rkov3u9wpwizp68xt27fdp1kdrcynlticab773d1ek.png') },
  { id: 2, name: 'D.N.G.P Arts and Science College',      img: proxy('https://ibots.in/wp-content/uploads/elementor/thumbs/ARTS-1997-rkov17c7jmx14k2u7f63vv00ducw26cmb8f5q59sv0.jpg') },
  { id: 3, name: 'Annai Muthukrishnan Institute of Tech', img: proxy('https://ibots.in/wp-content/uploads/elementor/thumbs/images-rkov1c1eht3gqlw0fz78qbtbcrpq4nv9zvol4j2tzw.jpeg') },
  { id: 4, name: 'K Ramakrishnan College of Engineering', img: proxy('https://ibots.in/wp-content/uploads/elementor/thumbs/k-ramakrishnan-college-of-engineering-logo-703-rkov1cz8on4r27unahlvatkry5l3ccz0c0c2lt1fto.jpg') },
];

var SCHOOLS = [
  { id: 1,  name: 'School 1',  img: proxy('https://ibots.in/wp-content/uploads/2026/03/1.png') },
  { id: 2,  name: 'School 2',  img: proxy('https://ibots.in/wp-content/uploads/2026/03/2.png') },
  { id: 3,  name: 'School 3',  img: proxy('https://ibots.in/wp-content/uploads/2026/03/3.png') },
  { id: 4,  name: 'School 4',  img: proxy('https://ibots.in/wp-content/uploads/2026/03/4.png') },
  { id: 5,  name: 'School 5',  img: proxy('https://ibots.in/wp-content/uploads/2026/03/5.png') },
  { id: 6,  name: 'School 6',  img: proxy('https://ibots.in/wp-content/uploads/2026/03/6.png') },
  { id: 7,  name: 'School 7',  img: proxy('https://ibots.in/wp-content/uploads/2026/03/7.png') },
  
  
];

var VISIBLE = 4;

function getLoopItems(items) {
  if (items.length <= VISIBLE) {
    return items.concat(
      items.map(function (item) {
        return Object.assign({}, item, { id: item.id + 1000 });
      })
    );
  }
  return items;
}

function LogoCarousel({ items, autoInterval }) {
  var loopItems   = getLoopItems(items);
  var maxIndex    = loopItems.length - VISIBLE;
  var pair        = useState(0);
  var current     = pair[0];
  var setCurrent  = pair[1];
  var intervalRef = useRef(null);

  var shift      = current * 25;
  var trackStyle = { transform: 'translateX(-' + shift + '%)' };

  function startAutoSlide() {
    intervalRef.current = setInterval(function () {
      setCurrent(function (prev) {
        return prev >= maxIndex ? 0 : prev + 1;
      });
    }, autoInterval || 5000);
  }

  function stopAutoSlide() {
    clearInterval(intervalRef.current);
  }

  useEffect(function () {
    startAutoSlide();
    return function () { stopAutoSlide(); };
  }, []);

  function handlePrev() { if (current > 0) setCurrent(current - 1); }
  function handleNext() { if (current < maxIndex) setCurrent(current + 1); }
  function handleDot(i) { setCurrent(i <= maxIndex ? i : maxIndex); }

  function getDotClass(i) {
    if (i >= current && i < current + VISIBLE) return 'ti__dot ti__dot--active';
    return 'ti__dot';
  }

  return (
    <div
      className="ti__carousel-wrap"
      onMouseEnter={stopAutoSlide}
      onMouseLeave={startAutoSlide}
    >
      <button
        className={current === 0 ? 'ti__arrow ti__arrow--disabled' : 'ti__arrow'}
        onClick={handlePrev}
      >←</button>

      <div className="ti__track-outer">
        <div className="ti__track" style={trackStyle}>
          {loopItems.map(function (item) {
            return (
              <div className="ti__logo-cell" key={item.id}>
                <img src={item.img} alt={item.name} className="ti__logo-img" />
              </div>
            );
          })}
        </div>
      </div>

      <button
        className={current === maxIndex ? 'ti__arrow ti__arrow--disabled' : 'ti__arrow'}
        onClick={handleNext}
      >→</button>

      <div className="ti__dots-row">
        {loopItems.map(function (item, i) {
          return (
            <button
              key={item.id}
              className={getDotClass(i)}
              onClick={function () { handleDot(i); }}
            />
          );
        })}
      </div>
    </div>
  );
}

function TrustedInstitutions() {
  return (
    <section className="ti__section">
      <div className="ti__header">
        <p className="ti__eyebrow">OUR NETWORK</p>
        <h2 className="ti__title">Trusted by Leading Institutions</h2>
        <p className="ti__sub">
          Many institutions collaborate with ibots to deliver impactful hackathons — enabling
          students to explore emerging technologies, build innovative solutions, and gain
          real-world problem-solving experience.
        </p>
      </div>

      <div className="ti__block">
        <div className="ti__block-label"><span>TRUSTED BY COLLEGES</span></div>
        <LogoCarousel items={COLLEGES} autoInterval={2000} />
      </div>

      <div className="ti__block">
        <div className="ti__block-label"><span>TRUSTED BY SCHOOLS</span></div>
        <LogoCarousel items={SCHOOLS} autoInterval={2000} />
      </div>
    </section>
  );
}

export default TrustedInstitutions;